import "./styles/global.css";
import { useFadeIn }   from "./hooks/useFadeIn";
import {
  siteInfo,
  navLinks,
  hero,
  about,
  savoirFaire,
  projects,
  contact,
} from "./data/content";
import {
  Navbar,
  Hero,
  About,
  SavoirFaire,
  Projets,
  Contact,
  Footer,
} from "./components";

export default function App() {
  const addRef = useFadeIn();

  return (
    <>
      <Navbar name={siteInfo.name} links={navLinks} />
      <Hero data={hero} />
      <About data={about} addRef={addRef} />
      <SavoirFaire data={savoirFaire} addRef={addRef} />
      <Projets data={projects} />
      <Contact data={contact} info={siteInfo} />
      <Footer name={siteInfo.name} tagline={siteInfo.footer} />
    </>
  );
}
